import { Link } from 'react-router-dom';
import { categories } from '@/mocks/seoData';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-lg font-heading font-semibold text-foreground-900 whitespace-nowrap">
              Sugargoo <span className="text-primary-600">Spread</span>
            </Link>
            <p className="mt-3 text-xs text-foreground-500 leading-relaxed">
              Your trusted independent resource for <strong>Sugargoo Spreadsheet</strong> product finds, 
              buying guides, and international shopping tips.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer">
                <i className="ri-external-link-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer">
                <i className="ri-shopping-bag-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-xs text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Home</Link>
              <Link to="/article/sugargoo-spreadsheet-guide" className="text-xs text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Spreadsheet Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Main Website</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">Popular Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">More Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(6).map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Sugargoo Spread. An independent informational resource. Not affiliated with Sugargoo.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">Privacy</Link>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">Terms</Link>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}